import { render } from "./App.vue?vue&type=template&id=2f03fcdc"
const script = {}

import exportComponent from "C:\\Users\\jose.pignataro\\Desktop\\gedi_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__